<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
@if (form()) {
    <div class="container white">
        <div class="topbar">
            <div class="title">
                <h1 class="h3 condensed">Gebruiker beheren</h1>
            </div>
            <div class="controls">
                <div
                    class="fab small"
                    id="btn-Exit"
                    matTooltip="Terug naar overzicht"
                    matTooltipPosition="below"
                    routerLink="/users">
                    <i class="fas fa-sign-out-alt"></i>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-md-12">
                <form [formGroup]="form()">
                    <mat-form-field class="w-100" id="name">
                        <input
                            formControlName="name"
                            matInput
                            name="name"
                            placeholder="Naam"
                            type="text">
                        <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100" id="email">
                        <input
                            formControlName="email"
                            matInput
                            name="email"
                            placeholder="E-mailadres"
                            type="email">
                        <mat-error>Vul een correct e-mailadres in</mat-error>
                    </mat-form-field>
                    <ng-select
                        (change)="onChangeGroup($event)"
                        [closeOnSelect]="false"
                        [hideSelected]="true"
                        [items]="roles"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="roleIds"
                        placeholder="Gebruikersrollen">
                    </ng-select>
                    @if (showCustomerAreaSelection) {
                        <ng-select
                            [items]="customers"
                            bindLabel="name"
                            bindValue="id"
                            formControlName="customer_id"
                            id="customers"
                            placeholder="Opdrachtgever">
                        </ng-select>
                    }
                    @if (filteredCustomerAreas) {
                        <ng-select
                            [closeOnSelect]="false"
                            [hideSelected]="true"
                            [items]="filteredCustomerAreas"
                            [multiple]="true"
                            bindLabel="name"
                            bindValue="id"
                            formControlName="customerAreaIds"
                            id="customerareas"
                            placeholder="Toegang tot klantgebieden">
                        </ng-select>
                    }
                </form>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-12 col">
                <div class="d-flex justify-content-between">
                    <button mat-button routerLink="/users">Terug</button>
                    <div>
                        @if (!(user.id === currentUser.id) && hasKeyValue(currentUser.roles, 'id', 22)) {
                            <button (click)="open2FADialog()" class="me-3" mat-button>Reset Tweestapsverificatie</button>
                        }
                        <button
                            (click)="save()"
                            [disabled]="form().invalid || saving || form().disabled"
                            color="primary"
                            id="btn-save"
                            mat-raised-button>
                            Opslaan
                            @if (saving) {
                                <i class="fas fa-circle-notch fa-spin"></i>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            @if (user) {
                <app-user-auth-log [user]="user"></app-user-auth-log>
            }
        </div>
    </div>
}

<ng-template #twoFATemplate>
    <h2 mat-dialog-title>Tweestapsverificatie</h2>

    <form [formGroup]="twoFAForm" (ngSubmit)="refresh2FAKey()">
        <mat-dialog-content>
            <p>Voer je 6-cijferige authenticatiecode in:</p>
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>2FA-code</mat-label>
                <input matInput formControlName="twoFactorCode" maxlength="6" autocomplete="one-time-code">
                @if (twoFAForm.get('twoFactorCode')?.hasError('required')) {
                    <mat-error>
                        Code is verplicht
                    </mat-error>
                }
                @if (twoFAForm.get('twoFactorCode')?.hasError('pattern')) {
                    <mat-error>
                        Voer een geldige 6-cijferige code in
                    </mat-error>
                }
            </mat-form-field>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Annuleren</button>
            <button mat-raised-button color="primary" type="submit">
                Verifiëren
            </button>
        </mat-dialog-actions>
    </form>
</ng-template>
